"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncedObject = exports.isSyncedObject = void 0;
const tslib_1 = require("tslib");
const is_primitive_1 = tslib_1.__importDefault(require("is-primitive"));
const shallow_equal_object_1 = require("shallow-equal-object");
const fast_safe_stringify_1 = tslib_1.__importDefault(require("fast-safe-stringify"));
exports.isSyncedObject = (v) => {
    return v instanceof SyncedObject;
};
class SyncedObject {
    // eslint-disable-next-line no-unused-vars
    constructor(props, ref, syncType) {
        this.props = Object.freeze(props || null);
        this._ref = Object.freeze(ref || null);
        this._syncType = Object.freeze(syncType || null);
    }
    get value() {
        return this.props;
    }
    get ref() {
        return this._ref;
    }
    get syncType() {
        return this._syncType;
    }
    toString() {
        if (!this.props)
            return null;
        return fast_safe_stringify_1.default(this.props);
    }
    equals(vo) {
        if (vo == null) {
            return false;
        }
        if (vo.props === undefined) {
            return false;
        }
        return shallow_equal_object_1.shallowEqual(this.props, vo.props);
    }
    isPrimitive() {
        return is_primitive_1.default(this.props);
    }
    static handleValidationError(e, ref) {
        console.log(e, ref);
    }
}
exports.SyncedObject = SyncedObject;
//# sourceMappingURL=SyncedObject.js.map